import { Button } from "./Button"
import "../components/CTASection.css";

export default function CTASection() {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-title">Ready to Transform Healthcare?</h2>
        <p className="cta-text">
          Join thousands of healthcare professionals trusting Natoshine for advanced pharmaceutical solutions.
        </p>
        <Button className="cta-btn"><a href="/contact" >Contact Sales</a></Button>
      </div>
    </section>
  )
}

